import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import fundo from "../../../styles/fundo.svg";
import "./style.css";

const Geral = styled.div`
  width: 98%;
  box-shadow: 0px 0px 2px #ccc;
  padding: 5px;
  background-color: #ffffff;
`;
const Table = styled.table`
  width: 99%;
  background-color: #fff;
  padding: 20px 20px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 0.5px;
  margin: 5px auto;

`;

export const TdButton = styled.td`
  font-size: 14px;
  font-weight: bold;
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  cursor: pointer;
`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 25px; 
`;

export const Tr = styled.tr`
  text-align: center;
  text-decoration: none;
  border: none;
  width: 100%;
  background-color: #fff;
  cursor: pointer;
  transition: transform 0.3s;

  &:hover {
    color: black;
    background-color: #f5f5f5;
  }

`;

export const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;


`;

export const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 

`;

export const Td1 = styled.td`
  padding-top: 15px;
  text-align: center;


`;

export const Td2 = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
`;

export const Td3 = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  span{
    margin: 0px 5px;
  }

`;

const Input = styled.input`
  width: 345px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 1px;
  height: 37px;


`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;

const Div = styled.div`
display: flex;
align-items: center;

  
  span{
    padding: 0px  10px;
  }
`;

const ButtonExport = styled.td`
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  background-color: #ccc;
  color: white;
  border-radius: 5px;
  width: 50px;
  text-align: center;
  align-items: center;
  height: 20px;
  margin-left: 10px;
  &:hover {
    background-image:url(${fundo});
  }

  
`;

const Grid = ({ setOnEdit, toggleModalParticipatesPorCurso, treinamentosEXATA }) => {


  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);


  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = treinamentosEXATA.filter((user) => {
        const columnsToSearch = [
          'titulo',
        ];

        // Verifica se algum dos valores nas colunas contém o termo de pesquisa
        return columnsToSearch.some((column) => {
          const columnValue = user[column] ? user[column].toLowerCase() : '';
          return columnValue.includes(term.toLowerCase());
        });
      });
      setFilteredUsers2(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }

    setIsLoading(false);
    // setSearchTerm('');
  };
  useEffect(() => {
    handleSearch(searchTerm);

  }, [searchTerm]);

  useEffect(() => {
    setFilteredUsers2(treinamentosEXATA);
  }, [treinamentosEXATA]);

  //--------------------------------------------------------------------------------------------------------------//
  const [filteredUsers2, setFilteredUsers2] = useState([]); // Inicializando como array vazio


  const handleEdit = (item) => {
    setOnEdit(item);
    toggleModalParticipatesPorCurso();
  };


  const exportToExcel = () => {
    const dadosParaExportar = filteredUsers2.map((item) => ({
      "Nome do Treinamento": item.titulo,
      "Data": item.data,
      "Qtd. Prevista": item.qtdPrevista,
      "Qtd. Participante": item.qtdParticipantes,
      "Faltante": item.faltantes,
      "Imprevisto": item.imprevistos,
    }));

    // Criar uma planilha
    const ws = XLSX.utils.json_to_sheet(dadosParaExportar);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Departamentos");

    // Criar um arquivo Excel e baixar
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "relatorio_treinamento.xlsx");
  };

  //--------------------------------------------------------------------------------------------------------------//




  // Estados de Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Itens por página

  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers2];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers2, sortConfig]);

  // Aplicação da Paginação (agora sobre os dados ordenados)
  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems2 = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  // Funções de Paginação
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };


  //--------------------------------------------------------------------------------------------------------------//

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };
  return (

    <Geral>

      <Td3 colSpan="7">
        <Input
          type="text"
          placeholder="Pesquisar... Ex: Power BI"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <Div>
          <div>
            <Button onClick={handlePrevPage} disabled={currentPage === 1}><ImArrowLeft size={20} /></Button>
            <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
            <Button onClick={handleNextPage} disabled={currentPage === totalPages}> <ImArrowRight size={20} /></Button>
          </div>
        </Div>

        <Div>
          <p>Exportar: </p>
          <ButtonExport onClick={exportToExcel}>Excel</ButtonExport>
        </Div>
      </Td3>
      <Table >

        <Thead>
          <Tr>
            <Th onClick={() => onColumnClick("titulo")} className={getSortClass("titulo")}>
              Nome do Treinamento: {getSortIcon("titulo")}
            </Th>
            <Th onClick={() => onColumnClick("data")} className={getSortClass("data")}>
              Data: {getSortIcon("data")}
            </Th>
            <Th onClick={() => onColumnClick("qtdPrevista")} className={getSortClass("qtdPrevista")}>
              Qtd. Prevista: {getSortIcon("qtdPrevista")}
            </Th>
            <Th onClick={() => onColumnClick("qtdParticipantes")} className={getSortClass("qtdParticipantes")}>
              Qtd. Participante: {getSortIcon("qtdParticipantes")}
            </Th>
            <Th onClick={() => onColumnClick("faltantes")} className={getSortClass("faltantes")}>
              Faltante: {getSortIcon("faltantes")}
            </Th>
            <Th onClick={() => onColumnClick("imprevistos")} className={getSortClass("imprevistos")}>
              Imprevisto: {getSortIcon("imprevistos")}
            </Th>



          </Tr>
        </Thead>
        <Tbody>
          {currentItems2.map((item, i) => (
            <Tr key={i} onClick={() => handleEdit(item)}>
              <Td>{item.titulo}</Td> {/* Título do treinamento */}
              <Td>{item.data}</Td> {/* Data do treinamento */}
              <Td>{item.qtdPrevista}</Td> {/* Quantidade prevista */}
              <Td>{item.qtdParticipantes}</Td> {/* Quantidade participante */}
              <Td>{item.faltantes}</Td> {/* Quantidade faltantes */}
              <Td>{item.imprevistos}</Td> {/* Quantidade imprevista */}
            </Tr>
          ))}
        </Tbody>

      </Table>

    </Geral>
  );
};


export default Grid;
